// iter v29 r210 — Widget Crediti per topbar (mobile + desktop).
//
// Mostra saldo + plan + badge "Gratis · illimitato".
// Cliccabile → /dashboard/crediti.
//
// Logica visualizzazione:
//   - beta_mode + plan=beta → "Gratis · illimitato" (sage green badge)
//   - free → "5 / mese" (rosso se a 0)
//   - base/pro/pro_agency → "X cr" (rosso se a 0)
//
// Fetch best-effort: se /credits/me fallisce, il widget si nasconde.

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Coins } from "@phosphor-icons/react";

export default function CreditsBadge() {
  const [me, setMe] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let on = true;
    (async () => {
      try {
        const { data } = await api.get("/credits/me");
        if (on) setMe(data);
      } catch {
        if (on) setHidden(true);
      }
    })();
    return () => { on = false; };
  }, []);

  if (hidden || !me) return null;

  // iter v32 r49j — Founder bypass: l'endpoint /credits/me ritorna
  // `founder: true, unlimited: true` per gli account founder. Il badge
  // mostra "∞ · founder" (verde sage). Senza questo, il founder vedeva
  // "0 crediti" rosso anche se in realtà non gli scaliamo nulla.
  const isFounder = !!(me.founder || me.unlimited);
  const isBeta = !isFounder && me.beta_mode && me.plan === "beta";
  const balance = Number(me.balance_total ?? 0);
  const isEmpty = !isFounder && !isBeta && balance <= 0;

  const labelShort = (isFounder || isBeta) ? "∞" : balance;
  const labelLong = isFounder
    ? "Founder · illimitato"
    : isBeta
      ? "Illimitato"
      : `${balance} crediti`;

  return (
    <Link
      to="/dashboard/crediti"
      data-testid="topbar-credits-badge"
      title={labelLong}
      className={[
        // iter v29 r221 — Mobile leggibilità: text 14.5px (era 13.5),
        // icona 17 (era 16), padding y aumentato.
        "inline-flex items-center gap-1.5 px-3 py-2 rounded-md text-[14.5px] font-semibold transition-colors border",
        (isFounder || isBeta)
          ? "bg-[#7C8B6E]/15 hover:bg-[#7C8B6E]/20 text-[#4A5A3D] border-[#7C8B6E]/35"
          : isEmpty
            ? "bg-[#C44A3A]/12 hover:bg-[#C44A3A]/18 text-[#C44A3A] border-[#C44A3A]/30"
            : "bg-white hover:border-[#7C8B6E] text-[#1C1C1A] border-[#E5E7E0]",
      ].join(" ")}
    >
      <Coins size={17} weight={(isFounder || isBeta) ? "fill" : "regular"} />
      <span className="hidden sm:inline">{labelLong}</span>
      <span className="sm:hidden">{labelShort}</span>
    </Link>
  );
}
